import { render, staticRenderFns } from "./InfluencerMatchSection.vue?vue&type=template&id=29c36992&"
import script from "./InfluencerMatchSection.vue?vue&type=script&lang=js&"
export * from "./InfluencerMatchSection.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerMatchSection.vue?vue&type=style&index=0&id=29c36992&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports